<template>
  <span class="font-display rounded-full font-semibold" :class="[sizeClasses, colorClasses]">
    {{ count }}
  </span>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = withDefaults(
  defineProps<{
    count: number | string
    size?: 'sm' | 'md'
    /** On-selection styling (e.g. active nav item). */
    active?: boolean
    /** `ink` for chips sitting next to a heading; `muted` (default) for nav counts. */
    tone?: 'muted' | 'ink'
  }>(),
  { size: 'sm', tone: 'muted' },
)

const sizeClasses = computed(
  () =>
    ({
      sm: 'px-2 py-px text-xs',
      md: 'inline-block min-w-6.5 px-2.5 py-0.75 text-center text-[13px]',
    })[props.size],
)

const colorClasses = computed(() => {
  if (props.active) return 'bg-surface text-primary-600 dark:text-white'
  return props.tone === 'ink' ? 'bg-grey-200 text-ink dark:bg-white/10' : 'bg-grey-200 text-grey-500 dark:bg-white/10 dark:text-faint'
})
</script>
